import React, { Fragment } from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Category } from "@models/category";
import { deleteRequest, fetchRequest } from "@actions/category";
import CategoriesTable from "@components/categories/Table";
import TableRenderer from "@hocs/TableRenderer";
import CategoryForm from "@components/categories/Form";
import { FormattedMessage } from "react-intl";
import { Button, Card, Col, Input, Row, Modal } from "antd";
import SearchCategoriesComponent from "@components/categories/Search";
import { NavLink } from "react-router-dom";

interface PropsFromState {
  loading: boolean;
  data: Category[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class CategoriesIndexPage extends React.Component<AllProps> {
  deleteCategory = (item: Category): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, search, currentPage } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/categories/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.create_new_category"
                defaultMessage={`Create Category`}
              />
            </Button>
          </NavLink>
        </div>

        <div className={"page-table-wrapper"}>
          <Card bordered={false} className={`page-table-header search-part`}>
            <SearchCategoriesComponent search={search} />
          </Card>

          <CategoriesTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteCategory}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ categories }: ApplicationState) => ({
  loading: categories.loading,
  errors: categories.errors,
  data: categories.data,
  count: categories.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(CategoriesIndexPage));
